export function addBrTag(oldStringItem) {
    let newStringItem = '';
    for (let i = 0; i < oldStringItem.length; i++) {
        if (oldStringItem[i] === '\n') {
            newStringItem += '<br />';
        } else {
            newStringItem += oldStringItem[i];
        }
    }
    return newStringItem;
}
